import * as Yup from 'yup';
import { EsFileMerge } from '@models';

export function useValidationSchema() {
  return Yup.object<EsFileMerge>().shape({
    mergeDate: Yup.string().nullable().required(),
    mergedEsFiles: Yup.array().nullable().required(),
  }) as Yup.Schema<EsFileMerge>;
}
